var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMicrosoftIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5625 8.4375H18V0.5625C18 0.252 17.748 0 17.4375 0H9.5625V8.4375Z",
    fill: "#4CAF50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4375 8.4375V0H0.5625C0.252 0 0 0.252 0 0.5625V8.4375H8.4375Z",
    fill: "#F44336"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4375 9.5625H0V17.4375C0 17.748 0.252 18 0.5625 18H8.4375V9.5625Z",
    fill: "#2196F3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5625 9.5625V18H17.4375C17.748 18 18 17.748 18 17.4375V9.5625H9.5625Z",
    fill: "#FFC107"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftIcon);
export default __webpack_public_path__ + "static/media/microsoftIcon.7aed6692.svg";
export { ForwardRef as ReactComponent };